import { Typography } from '@mui/material';
import type { AuditLog } from '@repo/api-gw-sdk';
import type { Row } from '@tanstack/react-table';
import { useState } from 'react';

import { JsonDialog } from '@/components/shared/jsonDialog';

export const AuditLogOperationCell = ({ row }: { row: Row<AuditLog> }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <Typography
        variant='subtitle1'
        className='underline hover:cursor-pointer hover:text-(--mui-palette-text-secondary)'
        onClick={() => setIsOpen(true)}
      >
        {row.original.operationName}
      </Typography>
      <JsonDialog
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={`Audit log parameters - ${row.original.operationName}`}
        data={row.original}
        closeTestId='close-audit-log-json-viewer'
      />
    </>
  );
};
